import {Component, OnInit} from '@angular/core';
import {HierarchyService} from '~/app/core/services/hierarchy.service';
import {HierarchyA} from '@model/HierarchyA';
import {HierarchyB} from '@model/HierarchyB';
import {HierarchyC} from '@model/HierarchyC';
import {HomeOffice} from '@model/HomeOffice';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {paths} from '~/app/app-paths';
import {FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {UserService} from '~/app/core/services/user.service';
import {Router} from '@angular/router';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {HierarchyTree} from '@model/HierarchyTree';
import { Observable,lastValueFrom } from 'rxjs';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-hierarchy-container',
  templateUrl: './hierarchy.container.html',
  styleUrls: ['./hierarchy.container.scss']
})
export class HierarchyContainerComponent implements OnInit {

  public selectedHomeOffice: HomeOffice;
  public selectedStoreLevel: any;
  public selectedStoreLevelParent: any;
  public oldKey: any;

  hierarchyListA$: Observable<HierarchyA[]>;
  hierarchyListB$: Observable<HierarchyB[]>;
  hierarchyListC$: Observable<HierarchyC[]>;
  topHierarchyData$: Observable<HierarchyTree[]>;
  bottomHierarchyData$: Observable<HierarchyTree[]>;
  storeCount$: Observable<any>;

  selectedLevel: number;
  chain: string = '';
  storeCount: any;
  levels: any;
  public levelButtonBoolean: boolean = true;
  selectedType: HierarchyA;

  constructor(public hierarchyService: HierarchyService,
              public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public userService: UserService,
              public router: Router,
              public localStorage: LocalStorageIndexedService) {
  }

  ngOnInit() {

    this.levels = Array.from(Array(100).keys());
    this.selectedLevel = 0;

    this.levelButtonBoolean = true;

    if (this.userService.selectedHomeOffice) {
      this.selectedHomeOffice = this.userService.selectedHomeOffice;
      this.loadingIndicator.hide();
    } else {      
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE)) {
        this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.loadingIndicator.hide();
      } else {
        this.loadingIndicator.hide();
        this.dialogService.showErrorNotificationForDuration("No home office is selected.", 2000);
        this.router.navigate([paths.home]);
      }
    }

    if (this.selectedHomeOffice !== undefined) {
      this.hierarchyListA$ = this.hierarchyService.getHierarchyListA(this.selectedHomeOffice.hoId);
      this.hierarchyListA$.subscribe(a => {
        this.selectedType = a[0];
      });

      this.hierarchyListB$ = this.hierarchyService.getHierarchyListB(this.selectedHomeOffice.hoId);
      // TODO ask Joey what the better way of doing this is
      // this.hierarchyListB$.subscribe(b => {
          // b.find(chain => {
          //   if (chain !== undefined) {
          //     this.chain = chain.chain;
          //     console.log('this.chain: ', this.chain);
          //   }
          // });
        // },
      // err => console.log(err),
      // () => console.log('Successfully set chain: ', this.chain));

      this.hierarchyListC$ = this.hierarchyService.getHierarchyListC(this.selectedHomeOffice.hoId);
      this.topHierarchyData$ = this.hierarchyService.getTopHierarchy(this.selectedHomeOffice.hoId);
      this.bottomHierarchyData$ = this.hierarchyService.getBottomHierarchy(this.selectedHomeOffice.hoId);
      if (this.selectedLevel > -1) {
        this.storeCount$ = this.hierarchyService.getStoresCount(this.selectedHomeOffice.hoId, this.selectedLevel);
      }
    }
  }


  addLevel(results) {
    lastValueFrom(this.hierarchyService.insertLevel(this.selectedHomeOffice.hoId, results.selectedLevel, results.levelUpdated,
      results.newTypeTextValue)).then(async result => {
      console.warn(result);
      if (result !== 0) {
        console.error(result);
      } else {
        this.dialogService.showSuccessNotification('Add Successful');
        this.hierarchyListA$ = this.hierarchyService.getHierarchyListA(this.selectedHomeOffice.hoId);
        this.topHierarchyData$ = this.hierarchyService.getTopHierarchy(this.selectedHomeOffice.hoId);
        this.hierarchyListC$ = this.hierarchyService.getHierarchyListC(this.selectedHomeOffice.hoId);
        this.bottomHierarchyData$ = this.hierarchyService.getBottomHierarchy(this.selectedHomeOffice.hoId);
      }
    });
  }

  deleteLevel(results) {
    lastValueFrom(this.hierarchyService.deleteLevel(this.selectedHomeOffice.hoId, results.selectedLevel, results.levelUpdated,
      results.newTypeTextValue)).then(async result => {
      console.warn(result);
      if (result !== 0) {
        console.error(result);
      } else {
        this.dialogService.showSuccessNotification('Delete Successful');
        this.hierarchyListA$ = this.hierarchyService.getHierarchyListA(this.selectedHomeOffice.hoId);
        this.topHierarchyData$ = this.hierarchyService.getTopHierarchy(this.selectedHomeOffice.hoId);
        this.hierarchyListC$ = this.hierarchyService.getHierarchyListC(this.selectedHomeOffice.hoId);
        this.bottomHierarchyData$ = this.hierarchyService.getBottomHierarchy(this.selectedHomeOffice.hoId);
      }
    });
  }

  updateLevel(results) {
    lastValueFrom(this.hierarchyService.updateLevel(this.selectedHomeOffice.hoId, results.selectedLevel, results.levelUpdated,
      results.newTypeTextValue)).then(async result => {
      console.warn(result);
      if (result !== 0) {
        console.error(result);
      } else {
        this.dialogService.showSuccessNotification('Update Successful');
        this.hierarchyListA$ = this.hierarchyService.getHierarchyListA(this.selectedHomeOffice.hoId);
        this.topHierarchyData$ = this.hierarchyService.getTopHierarchy(this.selectedHomeOffice.hoId);
        // TODO need to call
        //      this.buildTypeArray();
        //       this.buildParentArrayFromType();
        this.hierarchyListC$ = this.hierarchyService.getHierarchyListC(this.selectedHomeOffice.hoId);
        this.bottomHierarchyData$ = this.hierarchyService.getBottomHierarchy(this.selectedHomeOffice.hoId);
      }
    });
  }

  addStore(results) {
    lastValueFrom(this.hierarchyService.insertStore(this.selectedHomeOffice.hoId, results)).then(async result => {
      console.warn('addStore result', result);
      if (result) {
        console.error(result);
      } else {
        this.dialogService.showSuccessNotification('Add Successful');
        this.hierarchyListC$ = this.hierarchyService.getHierarchyListC(this.selectedHomeOffice.hoId);
        this.bottomHierarchyData$ = this.hierarchyService.getBottomHierarchy(this.selectedHomeOffice.hoId);
      }
    });

  }

  deleteStore(results) {
    lastValueFrom(this.hierarchyService.deleteStore(this.selectedHomeOffice.hoId, results)).then(async result => {
      console.warn('deleteStore result', result);
      if (result) {
        console.error(result);
      } else {
        this.dialogService.showSuccessNotification('Delete Successful');
        this.hierarchyListC$ = this.hierarchyService.getHierarchyListC(this.selectedHomeOffice.hoId);
        this.bottomHierarchyData$ = this.hierarchyService.getBottomHierarchy(this.selectedHomeOffice.hoId);
      }
    });
  }

  updateStore(results) {
    lastValueFrom(this.hierarchyService.updateStore(this.selectedHomeOffice.hoId, results)).then(async result => {
      console.warn('updateStore result', result);
      if (result) {
        console.error(result);
      } else {
        this.dialogService.showSuccessNotification('Update Successful');
        this.hierarchyListC$ = this.hierarchyService.getHierarchyListC(this.selectedHomeOffice.hoId);
        this.bottomHierarchyData$ = this.hierarchyService.getBottomHierarchy(this.selectedHomeOffice.hoId);
      }
    });
  }


}
